import { getPatientName } from "core/model/patients";
import { Patient as PatientType } from "core/types";
import { FONT_WEIGHT_BOLD, Title } from "ds_legacy/materials/typography";

export function PatientIdentifier({ patient }: { patient: PatientType }) {
  const patientName = getPatientName(patient);

  if (patientName)
    return (
      <Title whiteSpace="nowrap">
        <span
          data-testid="patient_name"
          style={{ fontWeight: FONT_WEIGHT_BOLD }}
        >
          {patientName}
        </span>
        &nbsp;<span data-testid="patient_id">({patient.user_id})</span>
      </Title>
    );

  return (
    <Title whiteSpace="nowrap">
      Patient&nbsp;
      <span data-testid="patient_id">{patient.user_id || ""}</span>
    </Title>
  );
}
